import { useApp } from '../hooks/useApp';
import { cestovkoOffersContext, useCestovkoOffersContext } from './CestovkoOffersProvider';
import { propertyOffersContext, usePropertyOffersContext } from './PropertyOffersProvider';
import { carkulkaOffersContext, useCarkulkaOffersContext } from './CarkulkaOffersProvider';
import { carkulkaExtraOffersContext, useCarkulkaExtraOffersContext } from './CarkulkaExtraOffersProvider';
import { useContext } from 'react';
import { Offer } from 'BrokerTsLib/src/dtos';
import { IOffersContext } from './OffersProvider';
import { IAvailableApps } from '../utils/availableApps';

const getContext = (app: IAvailableApps['appId'] | null) => {
    switch (app) {
        case 'cestovko': return cestovkoOffersContext;
        case 'chaloupka': return propertyOffersContext;
        case 'carkulka': return carkulkaOffersContext;
        case 'carkulka-extra': return carkulkaExtraOffersContext;
        default: throw new Error("unknow app");
    }
}

export const useGetOffersContext = () => {
    const { app } = useApp()
    let ctx: React.Context<IOffersContext<any>> = getContext(app)

    return useContext(ctx)
}
